import React, { useEffect, useState } from 'react';
import { TreeSelect } from 'antd';
import useMyEquipoComponentsApi from 'pages/liftlogic/v2/Components/useMyEquipoComponentsApi';

// Mapea el árbol anidado de la API ({id,name,node_type,children}) al treeData
// de antd TreeSelect (value=id del nodo).
function toTreeData(nodes) {
  return (nodes || []).map((n) => ({
    value: n.id,
    title: n.node_type ? `${n.name} · ${n.node_type}` : n.name,
    children: toTreeData(n.children),
  }));
}

/**
 * Selector de un nodo del árbol de componentes de un equipo. Reusable en
 * cualquier flujo donde se quiera asociar algo a un componente.
 *
 * Props: equipoId, value (id|null), onChange(id|null), disabled, placeholder, allowClear, style
 */
function ComponentTreeSelect({
  equipoId,
  value,
  onChange,
  disabled = false,
  placeholder = 'Seleccionar componente…',
  allowClear = true,
  style,
}) {
  const api = useMyEquipoComponentsApi();
  const [treeData, setTreeData] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    let alive = true;
    if (!equipoId) {
      setTreeData([]);
      return undefined;
    }
    setLoading(true);
    api
      .getTree(Number(equipoId))
      .then((d) => {
        if (alive) setTreeData(toTreeData(d?.tree || []));
      })
      .catch(() => {
        if (alive) setTreeData([]);
      })
      .finally(() => {
        if (alive) setLoading(false);
      });
    return () => {
      alive = false;
    };
  }, [equipoId, api]);

  return (
    <TreeSelect
      value={value ?? undefined}
      onChange={(v) => onChange?.(v ?? null)}
      treeData={treeData}
      loading={loading}
      disabled={disabled || !equipoId}
      placeholder={!equipoId ? 'Sin equipo asociado' : placeholder}
      allowClear={allowClear}
      showSearch
      treeNodeFilterProp="title"
      treeDefaultExpandAll
      style={{ width: '100%', ...style }}
    />
  );
}

export default ComponentTreeSelect;
export { toTreeData };
